export default __webpack_public_path__ + "static/media/thumbnail_1920x800.f6502861.jpg";